import { MAP_TYPES } from '@deck.gl/carto';

const TRACT_PREDICTIONS_SOURCE_ID = 'tractPredictionsSource';

function source(socioeconomicFactor, tractcode) {
  return {
    id: TRACT_PREDICTIONS_SOURCE_ID,
    type: MAP_TYPES.QUERY,
    connection: 'carto_dw',
    data: `
    SELECT
      broadband,
      ${socioeconomicFactor}
    FROM
      carto-dw-ac-cn5bemsi.shared.tract_predictions AS predictions
    JOIN
      carto-dw-ac-cn5bemsi.shared.tracts AS tracts ON tracts.geoid = predictions.geoid
    WHERE
      tracts.tractcode = ${tractcode}
    `,
    queryParameters: {
      socioeconomicFactor,
      tractcode,
    },
  };
}

export default source;
